import { ca } from '@cian/analytics';

export function trackClickViewLayoutsOffersButton() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'layout_to_flats',
    useLastProducts: true,
  });
}

export function trackClick3DTourView() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Layouts',
    action: 'Click',
    label: '3dtour_viewer',
    useLastProducts: true,
  });
}
